<div container classes="container--1096">
  <div class="references__accordion position-relative z-0 d-flex flex-column gap-3" ngbAccordion
    #accordions="ngbAccordion">
    <div ngbAccordionItem="references-item" [destroyOnHide]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton id="references-toggle">
          <h3 class="mb-0">References</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="references-content">
              <ol>
                <li>
                  Scheiner G, Weiner S, Kruger DF, Pettus J. Screening for Type 1 Diabetes: Role of the Diabetes Care
                  and Education Specialist. ADCES in Practice. 2022;10(5):20-25.
                  doi:https://doi.org/10.1177/2633559x221110216
                </li>
                <li>
                  Centers for Disease Control and Prevention. Diabetes Tests. Centers for Disease Control and
                  Prevention. Published November 1, 2021.
                  https://www.cdc.gov/diabetes/basics/getting-tested.html
                </li>
                <li>
                  Phillip M, Achenbach P, Addala A, et al. Consensus Guidance for Monitoring Individuals With Islet
                  Autoantibody–Positive Pre-Stage 3 Type 1 Diabetes. Diabetes care. 2024;47(8).
                  doi:https://doi.org/10.2337/dci24-0042
                </li>
                <li>
                  Beyond Type 1. Screening for Type 1 Diabetes. Beyond Type 1.
                  https://beyondtype1.org/screening-for-type-1-diabetes/
                </li>
                <li>
                  American Diabetes Association Professional Practice Committee. Diagnosis and Classification of
                  Diabetes: Standards of Care in Diabetes—2024. Diabetes Care. 2023;47(Supplement_1):S20-S42.
                  doi:https://doi.org/10.2337/dc24-s002
                </li>
                <li>
                  Sanofi. Request a T1D Screening | Screen for Type 1 Diabetes. Screen for Type 1 Diabetes Patient Site.
                  Published 2025.
                  https://www.screenfortype1.com/request-a-t1d-screening/doi:https://doi.org/10.1177/2633559x221110216
                </li>
                <li>
                  American Diabetes Association Professional Practice Committee. Diagnosis and Classification of
                  Diabetes: Standards of Care in Diabetes—2024. Diabetes Care. 2023;47(Supplement_1):S20-S42.
                  doi:https://doi.org/10.2337/dc24-s002
                </li>
                <li>
                  Diabetes Leadership Council. Type 1 Diabetes Early Detection. Gettingaheadoftype1.org. Published 2025.
                  https://www.gettingaheadoftype1.org/resources/providers
                </li>
                <li>
                  Greenbaum C, VanBuecken D, Lord S. Disease-Modifying Therapies in Type 1 Diabetes: A Look into the
                  Future of Diabetes Practice. Drugs. 2019;79(1):43-61. doi:10.1007/s40265-018-1035-y
                </li>
                <li>
                  Gilad Twig, Maya Simchoni, Inbal Dym, Adi Vinograd, Cole D. Bendor, Aya Bardugo, Avishai M. Tsur,
                  Inbar Zucker, Miri Lutski, Estela Derazne, Cheli Cohen-Melzer, Gabriel Chodick, Arnon Afek, Hertzel
                  C. Gerstein, Orit Pinhas-Hamiel, Amir Tirosh; Thyroid, Celiac, and Other Autoimmune Diseases and the
                  Risk of Incident Type 1 Diabetes in Young Adulthood. Diabetes Care 20 March 2026; 49 (4): 581–588.
                  https://doi.org/10.2337/dc25-1423
                </li>
                <li>
                  11 Ghalwash M, Dunne J, Lundgren M et al.<br />
                  Two-age islet-autoantibody screening for childhood type 1 diabetes: a prospective cohort study<br />
                  The Lancet Diabetes &amp; Endocrinology, 2022; 10, 589-596
                </li>
                <li>
                  Andrea K Steck, Marian J Rewers, Genetics of Type 1 Diabetes, Clinical Chemistry, Volume 57, Issue 2,
                  1 February 2011, Pages 176–185, https://doi.org/10.1373/clinchem.2010.148221
                </li>
              </ol>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
